import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import Select from "@mui/material/Select";
import useFetch from "../../../../../hooks/useFetch";
import { FormControl, FormHelperText, MenuItem } from "@mui/material";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "assign-book-form";

const AddBooks = forwardRef(({ close, get, Id }, ref) => {
  const [booksList, setBooksList] = useState();
  const [books, setBooks] = useState();
  const [selected, setSelected] = useState();
  const [added, setAdded] = useState();
  const [call, setCall] = useState();
  const [bookIds, setBookIds] = useState({
    book_ids: [],
  });

  const getBooks = useFetch({
    method: "GET",
    url: `management/books/`,
    noHeader: false,
    trigger: true,
    setter: setBooks,
  });

  const getBooksList = useFetch({
    method: "GET",
    url: `management/users/${Id}/user_books/`,
    noHeader: false,
    trigger: true,
    setter: setBooksList,
  });

  const newBook = useFetch({
    method: "PATCH",
    url: `management/users/${Id}/user_books/`,
    noHeader: false,
    trigger: false,
    caller: get,
    data: bookIds,
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    // values: call,
  });

  const onSubmit = (e) => {
    // const formData = new FormData();
    // formData.append("book_ids", bookIds);
    // setCall(formData);
    newBook.reFetch();
  };

  useEffect(() => {
    setBookIds({ ...bookIds, book_ids: booksList?.map((book) => book.id) });
  }, [booksList]);

  const handleSelect = (event) => {
    if (bookIds.book_ids.length === 0) {
      setBookIds({
        book_ids: [event.target.value],
      });
    } else {
      setBookIds((prevState) => ({
        ...prevState,
        book_ids: [...prevState.book_ids, event.target.value],
      }));
    }
  };

  function updateStudent(state, newStudentId) {
    const newResults = state.results.map((result) => {
      if (result.id === selected) {
        return {
          ...result,
          student: [...result.student, newStudentId],
        };
      }

      return result;
    });

    return {
      ...state,
      results: newResults,
    };
  }
  useEffect(() => {
    newBook.status === 202 && close();
  }, [newBook.status]);

  return (
    <ModalShell
      ref={ref}
      close={close}
      title="افزودن جزوه"
      subtitle="یک جزوه را برای این دانش‌آموز انتخاب کنید"
      width="max-w-[44rem]"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={newBook.loading}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {newBook.loading ? "در حال ثبت…" : "افزودن"}
          </button>
        </div>
      }
    >
      <form id={FORM_ID} onSubmit={handleSubmit(onSubmit)} className="text-sm">
        <div>
          <label htmlFor="books" className="mb-2xs block text-sm text-ink-muted">
            لیست جزوات
          </label>
          <FormControl error={errors.books ? true : false} fullWidth>
            <Select
              value={selected}
              {...register("books", {
                required: "جزوه را وارد کنید",
              })}
              fullWidth
              onChange={handleSelect}
            >
              {books?.results.map((book) => {
                return (
                  <MenuItem key={book.id} value={book.id}>
                    {book.booksname}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText>{errors?.books?.message}</FormHelperText>
          </FormControl>
        </div>
      </form>
    </ModalShell>
  );
});

export default AddBooks;

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
